import { INSTALL, UNINSTALL, BIND, UNBIND } from "@/constants/util";

export const notInstallAndNotBind = (current) =>
  current.bindState === false && current.status === UNINSTALL;

export const notInstallAndBind = (current) =>
  current.bindState === false && current.status === UNINSTALL;

export const installAndBind = (current) =>
  current.bindState === true && current.status === INSTALL;

export const install = (current) => current.status === INSTALL;
